import '../assets/NcEmojiPicker-B-4WNYcx.css';
import { Emoji as u, Picker as f, EmojiIndex as p } from "emoji-mart-vue-fast";
import { r as m, u as d, v as h, w as k, a as n } from "./_l10n-BZu8wI2q.mjs";
import { g as v, s as _ } from "./emoji-k4gWHxrE.mjs";
import { C as o } from "./GenColors-D0bH59Rv.mjs";
import y from "emoji-mart-vue-fast/data/all.json";
import { n as c } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import g from "../Components/NcButton.mjs";
import { N as S } from "./NcColorPicker-C29EJ5Gw.mjs";
import { N as w } from "./NcPopover--V3R3EKV.mjs";
import { N as C } from "./NcTextField-BAKyJTQ0.mjs";
m(k, h, d);
const b = {
  name: "CircleIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var j = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon circle-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(i) {
    return e.$emit("click", i);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, $ = [], N = /* @__PURE__ */ c(
  b,
  j,
  $,
  !1,
  null,
  null,
  null,
  null
);
const E = N.exports;
let a;
const P = {
  search: n("Search emoji"),
  notfound: n("No emoji found"),
  categories: {
    search: n("Search results"),
    recent: n("Frequently used"),
    smileys: n("Smileys & Emotion"),
    people: n("People & Body"),
    nature: n("Animals & Nature"),
    foods: n("Food & Drink"),
    activity: n("Activities"),
    places: n("Travel & Places"),
    objects: n("Objects"),
    symbols: n("Symbols"),
    flags: n("Flags"),
    custom: n("Custom")
  }
}, l = [
  new o(255, 222, 52, n("Neutral skin color")),
  new o(228, 205, 166, n("Light skin tone")),
  new o(250, 221, 192, n("Medium light skin tone")),
  new o(174, 129, 87, n("Medium skin tone")),
  new o(158, 113, 88, n("Medium dark skin tone")),
  new o(96, 79, 69, n("Dark skin tone"))
], x = {
  name: "NcEmojiPicker",
  components: {
    Emoji: u,
    IconCircle: E,
    NcButton: g,
    NcColorPicker: S,
    NcPopover: w,
    NcTextField: C,
    Picker: f
  },
  props: {
    /**
     * The emoji-set
     */
    activeSet: {
      type: String,
      default: "native"
    },
    /**
     * Show preview section when hovering emoji
     */
    showPreview: {
      type: Boolean,
      default: !1
    },
    /**
     * Allow unselecting the selected emoji
     */
    allowUnselect: {
      type: Boolean,
      default: !1
    },
    /**
     * Selected emoji to allow unselecting
     */
    selectedEmoji: {
      type: String,
      default: ""
    },
    /**
     * The fallback emoji in the preview section
     */
    previewFallbackEmoji: {
      type: String,
      default: "grinning"
    },
    /**
     * The fallback text in the preview section
     */
    previewFallbackName: {
      type: String,
      default: n("Pick an emoji")
    },
    /**
     * Whether to close the emoji picker after picking one
     */
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    /**
     * Selector for the popover container
     */
    container: {
      type: [String, Object, Element, Boolean],
      default: "body"
    }
  },
  emits: [
    "select",
    "select-data",
    "unselect"
  ],
  setup() {
    return a || (a = new p(y)), {
      // Non-reactive constants
      emojiIndex: a,
      skinTonePalette: l,
      i18n: P
    };
  },
  data() {
    const r = v();
    return {
      /**
       * The current active color from the skin tone palette
       */
      currentColor: l[r - 1],
      /**
       * The current active skin tone
       * @type {1|2|3|4|5|6}
       */
      currentSkinTone: r,
      search: "",
      open: !1
    };
  },
  computed: {
    native() {
      return this.activeSet === "native";
    }
  },
  methods: {
    t: n,
    clearSearch() {
      var e, t;
      this.search = "";
      const r = (t = (e = this.$refs.search) == null ? void 0 : e.$refs.inputField) == null ? void 0 : t.$refs.input;
      r && r.focus();
    },
    /**
     * Update the current skin tone by the result of the color picker
     * @param {string} color Color set
     */
    onChangeSkinTone(r) {
      const e = this.skinTonePalette.findIndex((t) => t.color.toLowerCase() === r.toLowerCase());
      e > -1 && (this.currentSkinTone = e + 1, this.currentColor = this.skinTonePalette[e], _(this.currentSkinTone));
    },
    select(r) {
      this.$emit("select", r.native), this.$emit("select-data", r), this.closeOnSelect && (this.open = !1);
    },
    unselect() {
      this.$emit("unselect");
    },
    afterShow() {
      var t, i;
      this.$refs.picker.$el.addEventListener("keydown", this.checkKeyEvent);
      const e = (i = (t = this.$refs.search) == null ? void 0 : t.$refs.inputField) == null ? void 0 : i.$refs.input;
      e && e.focus();
    },
    afterHide() {
      this.$refs.picker.$el.removeEventListener("keydown", this.checkKeyEvent);
    },
    checkKeyEvent(r) {
      if (r.key !== "Tab")
        return;
      const t = this.$refs.picker.$el.querySelectorAll(
        "button, input"
      ), i = t.length - 1;
      if (t.length <= 1) {
        r.preventDefault();
        return;
      }
      r.shiftKey === !1 && r.target === t[i] ? (r.preventDefault(), t[0].focus()) : r.shiftKey === !0 && r.target === t[0] && (r.preventDefault(), t[i].focus());
    }
  }
};
var T = function() {
  var e = this, t = e._self._c;
  return t("NcPopover", e._g(e._b({ attrs: { shown: e.open, container: e.container, "popup-role": "dialog" }, on: { "update:shown": function(i) {
    e.open = i;
  }, "after-show": e.afterShow, "after-hide": e.afterHide }, scopedSlots: e._u([{ key: "trigger", fn: function(i) {
    return [e._t("default", null, null, i)];
  } }], null, !0) }, "NcPopover", e.$attrs, !1), e.$listeners), [t("Picker", e._b({ ref: "picker", attrs: { "auto-focus": !1, color: "var(--color-primary-element)", data: e.emojiIndex, emoji: e.previewFallbackEmoji, i18n: e.i18n, native: e.native, "emoji-size": 20, "per-line": 8, "picker-styles": { width: "320px" }, "show-preview": e.showPreview, skin: e.currentSkinTone, "show-skin-tones": !1, title: e.previewFallbackName, role: "dialog", "aria-modal": "true", "aria-label": e.t("Emoji picker") }, on: { select: e.select }, scopedSlots: e._u([{ key: "searchTemplate", fn: function(i) {
    return [t("div", { staticClass: "search__wrapper" }, [t("NcTextField", { ref: "search", staticClass: "search", attrs: { value: e.search, label: e.t("Search"), "label-visible": !0, placeholder: e.i18n.search, "trailing-button-icon": "close", "trailing-button-label": e.t("Clear search"), "show-trailing-button": e.search !== "" }, on: { "update:value": [function(s) {
      e.search = s;
    }, function(s) {
      return i.onSearch(e.search);
    }], "trailing-button-click": function(s) {
      e.clearSearch(), i.onSearch(e.search);
    } } }), t("NcColorPicker", { attrs: { "palette-only": "", container: e.container, palette: e.skinTonePalette, value: e.currentColor.color }, on: { "update:value": e.onChangeSkinTone } }, [t("NcButton", { attrs: { "aria-label": e.t("Skin tone"), type: "tertiary-no-background" }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [t("IconCircle", { style: { color: e.currentColor.color }, attrs: { title: e.currentColor.name, size: 20 } })];
    }, proxy: !0 }], null, !0) })], 1)], 1)];
  } }, e.allowUnselect && e.selectedEmoji ? { key: "customCategory", fn: function() {
    return [t("div", { staticClass: "emoji-mart-category-label" }, [t("h3", { staticClass: "emoji-mart-category-label" }, [e._v(" " + e._s(e.t("Selected")) + " ")])]), t("Emoji", { staticClass: "emoji-selected", attrs: { data: e.emojiIndex, emoji: e.selectedEmoji, native: !0, size: 32 }, on: { click: e.unselect } }), t("Emoji", { staticClass: "emoji-delete", attrs: { data: e.emojiIndex, emoji: ":x:", native: !0, size: 10 }, on: { click: e.unselect } })];
  }, proxy: !0 } : null], null, !0) }, "Picker", e.$attrs, !1))], 1);
}, F = [], I = /* @__PURE__ */ c(
  x,
  T,
  F,
  !1,
  null,
  "54cb91eb",
  null,
  null
);
const R = I.exports;
export {
  R as N
};
